// 解析出路由中的纯字符串截取
export function getRouterStr (routerPath) {
  let reg = /\D/g
  let router = routerPath.match(reg)
  router[router.length - 1] == '/' ? router.pop() : null
  return router.join('')
}

// 合并路由重合page
export function mergeNoSAASRouter (_router, fliePath, NOSAAS_PAGES) {
  console.log('mergeNoSAASRouter', _router, fliePath, NOSAAS_PAGES)
  let _val = NOSAAS_PAGES[fliePath]
  if (NOSAAS_PAGES && _val) {
    _router.children.forEach((cmp) => {
      let _cmp = _val[cmp.path]
      if (_cmp) {
        cmp.component = _cmp
        cmp.__spCompanyId = process.env.VUE_APP_COMPANY_ID
      }
    })
  }
  return _router
}
